module.exports = __webpack_public_path__ + "img/prod_yeji.c1b64cce.png";